export default {
    //获取出生年龄，周岁、月、天、时、分、秒
    getGrowAge(birthday) {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var day = now.getDate();
        var hour = now.getHours();
        var minute = now.getMinutes();
        var second = now.getSeconds();
        var myDate = new Date(birthday);
        var myYear = myDate.getFullYear();
        var myMonth = myDate.getMonth() + 1;
        var myDay = myDate.getDate();
        var myHour = myDate.getHours();
        var myMinute = myDate.getMinutes();
        var mySecond = myDate.getSeconds();
        var gapSecond = second - mySecond;
        if (gapSecond < 0) {
            minute -= 1;
            gapSecond = 60 - mySecond + second;
        }
        var gapMinute = minute - myMinute;
        if (gapMinute < 0) {
            hour -= 1;
            gapMinute = 60 - myMinute + minute;
        }
        var gapHour = hour - myHour;
        if (gapHour < 0) {
            day -= 1;
            gapHour = 24 - myHour + hour;
        }
        var gapDay = day - myDay;
        if (gapDay < 0) {
            month -= 1;
            gapDay = this.getDaysOfMonth(birthday) - myDay + day;
        }
        var gapMonth = month - myMonth;
        if (gapMonth < 0) {
            year -= 1;
            gapMonth = 12 - myMonth + month;

        }
        var gapYear = year - myYear;
        if (gapYear < 0) {
            gapYear = 0;
        }
        let data = {
            year: gapYear,
            month: gapMonth,
            day: gapDay,
        }
        // var dateStr = (gapYear > 0 ? gapYear + "岁 " : "") +
        //     (gapMonth > 0 ? gapMonth + "月 " : "") +
        //     (gapDay > 0 ? gapDay + "天 " : "") +
        //     (gapHour > 0 ? gapHour + "时 " : "") +
        //     (gapMinute > 0 ? gapMinute + "分 " : "") +
        //     (gapSecond > 0 ? gapSecond + "秒 " : "");
        return data;
    },
    //获取当月的天数
    getDaysOfMonth(dateStr) {
        var date = new Date(dateStr);
        var year = date.getFullYear();
        var mouth = date.getMonth() + 1;
        var day = 0;
        if (mouth == 2) {
            day = this.isLeapYear(year) ? 29 : 28;
        } else if (mouth == 1 || mouth == 3 || mouth == 5 ||
            mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12) {
            day = 31;
        } else {
            day = 30;
        }
        return day;
    },
    //判断是否为闰年
    isLeapYear(year) {
        return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
    },
    getAgeNum(birthday) {
        if (
            birthday !== null &&
            birthday !== undefined &&
            birthday !== ""
        ) {
            var newDate = new Date();
            var enroll = new Date(birthday);
            let time = newDate.getTime() - enroll.getTime(); //计算时间差
            let day = parseInt(time / (24 * 60 * 60 * 1000)); //转换成天 //不足一月
            let a = day / (99 * 365);
            return a;
        }
    },
    formatData(val) {
        let date = {
            yyyy: val.getFullYear(),
            MM: val.getMonth() + 1,
            dd: val.getDate(),
            hh: val.getHours(),
            mm: val.getMinutes(),
            ss: val.getSeconds(),
        };
        return date.yyyy + "/" + date.MM + "/" + date.dd;
    },
    formatDateTime(val) {
        let date = {
            yyyy: val.getFullYear(),
            MM: val.getMonth() + 1,
            dd: val.getDate(),
            hh: val.getHours(),
            mm: val.getMinutes(),
            ss: val.getSeconds(),
        };
        return date.yyyy + "-" + date.MM + "-" + date.dd + ' ' + date.hh + ':' + date.mm + ':' + date.ss;
    },
};
